import React from "react";

export const Techstack = (props) => {
  return (
    <div id="techstack" className="text-center">
      <div className="container">
        <div className="techstack-title">
          <h2>Technology Stack</h2>
          <p>Here’s a selection of the technology stacks I’ve worked with.</p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  {" "}
                  <i className={d.icon}></i>
                  <div className="techstack-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
